export default function(customEvent){
  this && this.dispatchEvent(customEvent);
}
